/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import { gsap } from "gsap";


/* eslint-disable no-console */
// console.log("Hello World! (from create-block-animated-background-block block)");
/* eslint-enable no-console */

let hero_timeline = gsap.timeline( {repeat: -1} );

let images = [...document.querySelectorAll('.ew-main-hero__images .ew-hero-background-layer')].slice(1).reverse();
hero_timeline.to(images, {x: "-100%", ease: "power1.inOut", duration: 0.8, delay: 2, stagger: 3});

// let maskNode = document.getElementById('mtMosaicFilter');
// let maskRect = document.querySelector(".wp-block-create-block-animated-background-block");

// console.log( { maskNode } )
// console.log( { maskRect } )

// let verticalHun = Math.ceil(maskRect.offsetHeight / 100);
// let verticalTwo = Math.ceil(maskRect.offsetHeight / 200);
// let vertical = 7;
// let rectSize = Math.ceil(maskRect.offsetHeight / vertical);
// let horizontal = Math.ceil(maskRect.offsetWidth / rectSize );
// let offset = ( ( ( rectSize * horizontal ) - maskRect.offsetWidth ) / 2 );

// let xmlns = "http://www.w3.org/2000/svg";

// const rects = [];
// for (let x = 0; x <= horizontal; x++) {
// 	for (let y = 0; y <= vertical; y++) {
// 		var rect = document.createElementNS(xmlns, "rect");
// 		rect.setAttributeNS(null, "x", ( (offset * -1) + ( rectSize * x ) ).toString());
// 		rect.setAttributeNS(null, "y", (rectSize * y).toString());
// 		rect.setAttributeNS(null, "width", (rectSize).toString());
// 		rect.setAttributeNS(null, "height", (rectSize).toString());
// 		rect.setAttributeNS(null, "fill", "white");
// 		maskNode.appendChild(rect);
// 		rects.push({ x, y, rect });
// 	}
// }

// increase to make middle squares go first
// const arrowShape = 5;
// reduce to make more random
// const constBase = 1;
// const layers = document.querySelectorAll(".ew-main-hero__images .ew-hero-background-layer").

const count = images.length;
for (const [i, image] of images.entries()) {



	// const sorted = rects
	// 	.map(({ x, y, rect }) => ({
	// 		rect,
	// 		score: (x * vertical + Math.abs(y - vertical * 0.5) * arrowShape) * (constBase + Math.random()),
	// 	}))
	// 	.toSorted((a, b) => a.score - b.score)
	// 	.map(r => r.rect);

	// reset all squares
	// hero_timeline.set(
	// 	sorted,
	// 	{
	// 		x: rectSize * 2,
	// 		y: () => rectSize * (Math.random() - 0.5),
	// 		autoAlpha: 0,
	// 		scale: 0.5,
	// 		transformOrigin: 'center',
	// 	}
	// );
	//
	// for (let j = 0; j < count; j++) {
	// 	hero_timeline.set(
	// 		images[j],
	// 		{
	// 			// restack all slides in order coming up to the current one
	// 			zIndex: 1 + (count - i + j - 1) % count,
	// 			// and set the (now empty) mask on the current one
	// 			maskImage: i == j ? 'url("#mtMosaicFilter")' : 'unset',
	// 		},
	// 	);
	// }

	// wait on previous slide
	// hero_timeline.set({}, {delay: 2});

	// animate squares
	// hero_timeline.to(
	// 	sorted,
	// 	{
	// 		x: 0,
	// 		y: 0,
	// 		autoAlpha: 1,
	// 		scale: 1.01,
	// 		stagger: 0.01,
	// 		duration: 2,
	// 		transformOrigin: 'center',
	// 		ease: 'power3.out'
	// 	},
	// );

	// remove mask on current slide on completion
	// hero_timeline.set(
	// 	image,
	// 	{
	// 		maskImage: 'unset',
	// 	},
	// );

	// extra delay after 1st iteration
	// hero_timeline.set({}, {delay: 2});

}

